var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","height":"1"}}):_c('v-divider',{staticStyle:{"border-color":"rgb(151 151 151 / 12%)"}}),_vm._l((_vm.resolvedRows),function(tpl,index){return _c('RouteListItem',{key:tpl.key || index,attrs:{"node":{
    name: 'EditEmailSetting',
    meta: {
      displayName: tpl.title,
      icon: 'mdi-email-newsletter',
      params: { emailTemplate: tpl.key }
    }
  }}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }